module.exports = __webpack_public_path__ + "static/invitor_bg.a241828a.png";